module.exports = __webpack_public_path__ + "img/thumbnails-14-memory-cards.a1e73525.png";